import React from "react";
import { I2cButton, I2cIcon } from "@webcomponents/i2cwebcomponents/dist/react";
import ReviewAttribute from "../../../../Components/SharedComponent/ReviewAttribute/ReviewAttribute";

/**
 * FileDownloadDisplay Component
 * Displays a file name with a download button
 * 
 * @param {string} label - The label for the attribute
 * @param {string} fileName - The file name/path to display and download
 * @param {function} onDownload - Callback function to handle file download
 */
const FileDownloadDisplay = ({ label, fileName, onDownload }) => {
  if (!fileName) return null;

  return (
    <div i2c-grid="12@md">
      <ReviewAttribute
        label={label}
        value={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
            }}
          >
            <span>{fileName}</span>
            <I2cButton
              size="small"
              variant="link color"
              onClick={() => onDownload(fileName)}
            >
              <I2cIcon
                slot="prefix"
                name="linear-document-download"
                label="download"
              />
            </I2cButton>
          </div>
        }
      />
    </div>
  );
};

export default FileDownloadDisplay;
